import React from 'react';
export function Footer() {
  return <footer className="bg-black text-bone-muted py-12 border-t border-gold-hairline" data-id="element-30">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center md:text-left flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-31">
        <div className="text-sm" data-id="element-32">
          <p className="mb-3 text-bone" data-id="element-33">
            © 2026 The Auction Protocol. All rights reserved.
          </p>
          <p className="text-xs max-w-xl leading-relaxed opacity-60" data-id="element-34">
            Disclaimer: The information provided in this guide is for
            educational purposes only and does not constitute financial, legal,
            or real estate advice. Real estate investing involves risk. Always
            consult with a licensed professional before making investment
            decisions.
          </p>
        </div>

        <div className="flex gap-6 text-sm font-medium" data-id="element-35">
          <a href="#" className="hover:text-gold transition-colors" data-id="element-36">
            Terms
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-37">
            Privacy
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-38">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}